var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 10.0003V12.0003H4.00033V10.0003H2.66699V12.0003C2.66699 12.7337 3.26699 13.3337 4.00033 13.3337H12.0003C12.7337 13.3337 13.3337 12.7337 13.3337 12.0003V10.0003H12.0003ZM11.3337 7.33366L10.3937 6.39366L8.66699 8.11366V2.66699H7.33366V8.11366L5.60699 6.39366L4.66699 7.33366L8.00033 10.667L11.3337 7.33366Z",
    fill: "#995E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownloadIcon);
export default __webpack_public_path__ + "static/media/FileDownloadIcon.ee7e5748.svg";
export { ForwardRef as ReactComponent };